import React, { useState } from "react";
import { AnimationOnScroll } from "react-animation-on-scroll";
import { useParallax } from "react-scroll-parallax";
import { Container, Row, Col, Image } from "react-bootstrap";
import "./Home.css";
import aboutBg from "../images/AboutBG.png";
import platformsBg from "../images/PlatformsBG.png";
import headerVideo from "../images/Header_02.mp4";
import forestVideo from "../images/Forest_Website.mp4";
import frogVideo from "../images/FrogSkill_Website.mp4";
import bloodroomVideo from "../images/Bloodroom_Website.mp4";

import { FaTwitter, FaSteam, FaYoutube, FaInstagram } from "react-icons/fa";

import "./Modal.css";
import Modal from "./Modal";

const Home = () => {
  const openInNewTab = (url) => {
    const newWindow = window.open(url, "_blank", "noopener,noreferrer");
    if (newWindow) newWindow.opener = null;
  };

  const [openModal, setOpenModal] = useState(false);

  const parallaxExplore = useParallax({
    translateX: [0, -15],
  });
  const parallaxBloodroom = useParallax({
    translateX: [-5, 15],
  });
  const parallaxFrog = useParallax({
    translateX: [0, -10],
  });

  const parallaxExploreMobile = useParallax({
    translateX: [0, -15],
  });
  const parallaxBloodroomMobile = useParallax({
    translateX: [-10, 10],
  });
  const parallaxFrogMobile = useParallax({
    translateX: [-5, -15],
  });

  return (
    <Container fluid className="noPadding">
      <div className="steamFlagDiv">
        <div className="steamFlagComposition cursorPointer">
          <Image
            className="steamFlag"
            src="./assets/SteamFlag_2.gif"
            onClick={() => {
              openInNewTab(
                "https://store.steampowered.com/app/2452320/Folly_Of_The_Wizards/"
              );
            }}
          ></Image>
          {/* <Image className='steamWishlist' src="./assets/SteamWishlist.png"></Image> */}
        </div>
      </div>
      <Row className="headerSection noPadding">
        <video className="headerImage" loop autoPlay muted playsinline>
          <source src={headerVideo} type="video/mp4" />
        </video>
        {/* <Image fluid className='headerImage' src="./assets/HeaderBG.png"></Image> */}
      </Row>
      <div className="borderMask">
        <Image
          fluid
          className="borderImage"
          src="./assets/BorderMask.png"
        ></Image>
      </div>

      <Row
        className="aboutSection"
        style={{ backgroundImage: `url(${aboutBg})` }}
      >
        <div className="subscribeOverlay showMobile"></div>
        <Col>
          <div className="aboutText">
            <AnimationOnScroll
              duration={1}
              delay={0}
              animateIn="animate__fadeIn"
              animateOnce="true"
            >
              <h2 className="colorOrange textBold">
                Welcome to Folly Of The Wizards
              </h2>
            </AnimationOnScroll>
            <AnimationOnScroll
              duration={1}
              delay={250}
              animateIn="animate__fadeIn"
              animateOnce="true"
            >
              <p>
                <br></br>A comedic 2D roguelike action game that puts you in the
                shoes of a clumsy wizard apprentice. Join a wacky wizard cult
                and use unique spells to defeat enemies, explore procedurally
                generated dungeons, and save the world from chaos.
                <br></br>
                But beware: the fate of the world rests on your shoulders, and
                even the smallest decision can have a huge impact. With charming
                hand-drawn art, quirky characters, and unpredictable gameplay,
                Folly of the Wizards is the perfect adventure for anyone who
                loves{" "}
                <span className="colorOrange">humor, magic, and mayhem</span> .
                <br></br>
                <br></br>
                <br></br>
                Are you ready to become a legendary clumsy wizard?
                <br></br>
                <br></br>
                <br></br>
              </p>
            </AnimationOnScroll>
            <AnimationOnScroll
              duration={1}
              delay={500}
              animateIn="animate__fadeIn"
              animateOnce="true"
            >
              <Image
                className="steamWishlistAbout cursorPointer"
                src="./assets/SteamWishlist.png"
                onClick={() => {
                  openInNewTab(
                    "https://store.steampowered.com/app/2452320/Folly_Of_The_Wizards/"
                  );
                }}
              ></Image>
            </AnimationOnScroll>
          </div>
        </Col>
        <div className="borderMask">
          <Image
            fluid
            className="borderImage borderImageInverted"
            src="./assets/BorderMask.png"
          ></Image>
        </div>
      </Row>

      <Row className="trailerSection">
        {/* <YouTube
          videoId="zasZcfy3ZkI"
          opts={trailerOpts}
          className="trailerVideo"
          onReady={onPlayerReady}
        /> */}
        {/* <iframe
          className="trailerVideo"
          title="Youtube player"
          sandbox="allow-same-origin allow-forms allow-popups allow-scripts allow-presentation"
          src={`https://youtube.com/embed/zasZcfy3ZkI?autoplay=0`}
        ></iframe> */}

        <div class="video-wrap">
          <div class="video-container">
            <iframe
              width="560"
              height="315"
              src="https://www.youtube.com/embed/zasZcfy3ZkI?si=ecdKI1OkEn4Rw4iI"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerpolicy="strict-origin-when-cross-origin"
              allowfullscreen
            ></iframe>
          </div>
        </div>
        {/* <Col className="trailerCol">
        </Col> */}
      </Row>

      <div className="borderMask">
        <Image
          fluid
          className="borderImage"
          src="./assets/BorderMask.png"
        ></Image>
      </div>
      <Row className="infoSection noPadding">
        {/* <Image className='textMaskInfo' src='./assets/TextMaskTest.png'></Image> */}
        <div className="infoImageDiv">
          <video
            className="infoImage hideMobile"
            loop
            autoPlay
            muted
            playsinline
            ref={parallaxExplore.ref}
          >
            <source src={forestVideo} type="video/mp4" />
          </video>
          {/* <Image className='infoImage' src='./assets/Forest_Website_1.gif' ref={parallaxExplore.ref}></Image> */}
        </div>
        <Col
          sm={{ span: "12", order: "first" }}
          md={{ span: "6", order: "first" }}
          className="infoVideoCol"
        >
          <div className="showMobile">
            <video
              className=" "
              loop
              autoPlay
              muted
              playsinline
              ref={parallaxExploreMobile.ref}
            >
              <source src={forestVideo} type="video/mp4" />
            </video>
            <div className="borderMask">
              <Image
                fluid
                className="borderImage borderImageInverted"
                src="./assets/BorderMask.png"
              ></Image>
            </div>
          </div>
        </Col>
        <Col
          className="infoTextCol "
          sm={{ span: "12", order: "last" }}
          md={{ span: "6", order: "last" }}
        >
          <Col md={0} lg={{ span: "1", order: "0" }}></Col>

          <Col
            md={{ span: "12", order: "last" }}
            lg={{ span: "9", order: "1" }}
          >
            <Image
              className="textMaskImage "
              src="./assets/TextMask.png"
            ></Image>

            <div className="infoTextDiv">
              <AnimationOnScroll
                duration={1}
                delay={500}
                animateIn="animate__fadeIn"
                animateOnce="true"
              >
                <h1 className="colorOrange">
                  Explore a beautiful <br></br> 2D World
                </h1>
              </AnimationOnScroll>
              <AnimationOnScroll
                duration={1}
                delay={550}
                animateIn="animate__fadeIn"
                animateOnce="true"
              >
                <Image
                  className="separatorBar"
                  src="./assets/SeparatorBar.png"
                ></Image>
              </AnimationOnScroll>
              <AnimationOnScroll
                duration={1}
                delay={750}
                animateIn="animate__fadeIn"
                animateOnce="true"
              >
                <p>
                  Adventure yourself in a beautiful 2D world illustrated with
                  captivating detail and charm. From the quirky wizard cults to
                  the magical creatures that roam the land, immerse yourself in
                  a world filled with humor and wonder. Every pixel has been
                  crafted with love and care to bring this unique universe to
                  life. Get ready to embark on an adventure like no other in
                  Folly of the Wizards.
                </p>
              </AnimationOnScroll>
            </div>
          </Col>
          <Col md={0} lg={{ span: "2", order: "2" }}></Col>
        </Col>
      </Row>
      <div className="borderMask">
        <Image
          fluid
          className="borderImage"
          src="./assets/BorderMask.png"
        ></Image>
      </div>
      <Row className="infoSection noPadding">
        <div className="infoImageDiv ">
          <video
            className="infoImage bloodroomImg hideMobile"
            loop
            autoPlay
            muted
            playsinline
            ref={parallaxBloodroom.ref}
          >
            <source src={bloodroomVideo} type="video/mp4" />
          </video>
          {/* <Image className='infoImage bloodroomImg' src='./assets/Bloodroom.png' ref={parallaxBloodroom.ref}></Image> */}
        </div>
        <Col
          sm={{ span: "12", order: "first" }}
          md={{ span: "6", order: "last" }}
          className="infoVideoCol"
        >
          <div className="showMobile bloodroomMobile">
            <video
              className=" bloodroomMobileVideo"
              loop
              autoPlay
              muted
              playsinline
              ref={parallaxBloodroomMobile.ref}
            >
              <source src={bloodroomVideo} type="video/mp4" />
            </video>
            <div className="borderMask">
              <Image
                fluid
                className="borderImage borderImageInverted"
                src="./assets/BorderMask.png"
              ></Image>
            </div>
          </div>
        </Col>
        <Col
          className="infoTextCol infoTextColInvert"
          sm={{ span: "12", order: "last" }}
          md={{ span: "6", order: "first" }}
        >
          <Col md={0} lg={{ span: "1", order: "0" }}></Col>

          <Col
            md={{ span: "12", order: "last" }}
            lg={{ span: "9", order: "1" }}
          >
            <Image
              className="textMaskImage textMaskImageInvert"
              src="./assets/TextMask.png"
            ></Image>
            <div className="infoTextDiv">
              <AnimationOnScroll
                duration={1}
                delay={500}
                animateIn="animate__fadeIn"
                animateOnce="true"
              >
                <h1 className="colorRed">
                  Make friends... <br></br> or enemies
                </h1>
              </AnimationOnScroll>

              <AnimationOnScroll
                duration={1}
                delay={550}
                animateIn="animate__fadeIn"
                animateOnce="true"
              >
                <Image
                  className="separatorBar"
                  src="./assets/SeparatorBar.png"
                ></Image>
              </AnimationOnScroll>

              <AnimationOnScroll
                duration={1}
                delay={750}
                animateIn="animate__fadeIn"
                animateOnce="true"
              >
                <p>
                  In Folly of the Wizards, your social skills are just as
                  important as your wizardry abilities. Will you befriend the
                  elite wizards and gain powerful allies, or will you stand up
                  against them and face their wrath? With every decision and
                  conversation, you can shape your relationships and alter the
                  course of your adventure. Choose wisely, as your actions will
                  have consequences in this wacky and unpredictable world. Are
                  you ready to make friends... or enemies?
                </p>
              </AnimationOnScroll>
            </div>
          </Col>
          <Col md={0} lg={{ span: "2", order: "2" }}></Col>
        </Col>
      </Row>
      <div className="borderMask">
        <Image
          fluid
          className="borderImage"
          src="./assets/BorderMask.png"
        ></Image>
      </div>
      <Row className="infoSection noPadding">
        {/* <Image className='textMaskInfo' src='./assets/TextMaskTest.png'></Image> */}
        <div className="infoImageDiv noPadding">
          <video
            className="infoImage hideMobile"
            loop
            autoPlay
            muted
            playsinline
            ref={parallaxFrog.ref}
          >
            <source src={frogVideo} type="video/mp4" />
          </video>
          {/* <Image className='infoImage' src='./assets/FrogSkill_Website_1.gif' ref={parallaxFrog.ref}></Image> */}
        </div>
        <Col
          sm={{ span: "12", order: "first" }}
          md={{ span: "6", order: "first" }}
          className="infoVideoCol"
        >
          <div className="showMobile">
            <video
              className=" "
              loop
              autoPlay
              muted
              playsinline
              ref={parallaxFrogMobile.ref}
            >
              <source src={frogVideo} type="video/mp4" />
            </video>
            <div className="borderMask">
              <Image
                fluid
                className="borderImage borderImageInverted"
                src="./assets/BorderMask.png"
              ></Image>
            </div>
          </div>
        </Col>
        <Col
          className="infoTextCol "
          sm={{ span: "12", order: "last" }}
          md={{ span: "6", order: "last" }}
        >
          <Col md={0} lg={{ span: "1", order: "0" }}></Col>

          <Col
            md={{ span: "12", order: "last" }}
            lg={{ span: "9", order: "1" }}
          >
            <Image
              className="textMaskImage "
              src="./assets/TextMask.png"
            ></Image>

            <div className="infoTextDiv ">
              <AnimationOnScroll
                duration={1}
                delay={500}
                animateIn="animate__fadeIn"
                animateOnce="true"
              >
                <h1 className="colorOrange">
                  Learn <br></br>Powerful Spells
                </h1>
              </AnimationOnScroll>
              <AnimationOnScroll
                duration={1}
                delay={500}
                animateIn="animate__fadeIn"
                animateOnce="true"
              >
                <Image
                  className="separatorBar"
                  src="./assets/SeparatorBar.png"
                ></Image>
              </AnimationOnScroll>
              <AnimationOnScroll
                duration={1}
                delay={500}
                animateIn="animate__fadeIn"
                animateOnce="true"
              >
                <p>
                  Unleash your inner wizard and learn powerful spells in Folly
                  of the Wizards! But be warned, your wizardly skills may not be
                  up to par as you stumble your way through casting spells
                  clumsily and incorrectly. To make matters worse, you can't
                  even read the wizardry glyphs on your scrolls! Will you
                  discover a powerful new spell, or accidentally turn your
                  allies into frogs? It's all part of the fun in this hilarious
                  2D roguelike adventure!
                </p>
              </AnimationOnScroll>
            </div>
          </Col>
          <Col md={0} lg={{ span: "2", order: "2" }}></Col>
        </Col>
      </Row>
      <div className="borderMask">
        <Image
          fluid
          className="borderImage "
          src="./assets/BorderMask.png"
        ></Image>
      </div>
      <Row
        className="platformsSection"
        style={{ backgroundImage: `url(${platformsBg})` }}
      >
        <Col sm={12} md={2}></Col>
        <Col xs={6} sm={6} md={2}>
          <div className="platformsLogosDiv">
            <AnimationOnScroll
              duration={1}
              delay={0}
              animateIn="animate__fadeIn"
              animateOnce="true"
            >
              <Image
                fluid
                className="platformLogoImg"
                src="./assets/SteamLogo.png"
              ></Image>
            </AnimationOnScroll>
          </div>
        </Col>
        <Col xs={6} sm={6} md={2}>
          <div className="platformsLogosDiv">
            <AnimationOnScroll
              duration={1}
              delay={250}
              animateIn="animate__fadeIn"
              animateOnce="true"
            >
              <Image
                fluid
                className="platformLogoImg"
                src="./assets/NintendoSwitch.png"
              ></Image>
            </AnimationOnScroll>
          </div>
        </Col>
        <Col xs={6} sm={6} md={2}>
          <div className="platformsLogosDiv">
            <AnimationOnScroll
              duration={1}
              delay={500}
              animateIn="animate__fadeIn"
              animateOnce="true"
            >
              <Image
                fluid
                className="platformLogoImg"
                src="./assets/PS5.png"
              ></Image>
            </AnimationOnScroll>
          </div>
        </Col>
        <Col xs={6} sm={6} md={2}>
          <div className="platformsLogosDiv">
            <AnimationOnScroll
              duration={1}
              delay={750}
              animateIn="animate__fadeIn"
              animateOnce="true"
            >
              <Image
                fluid
                className="platformLogoImg"
                src="./assets/XboxLogo.png"
              ></Image>
            </AnimationOnScroll>
          </div>
        </Col>
        <Col sm={12} md={2}></Col>
      </Row>

      <Container>
        <Row className="footerSection">
          <Col
            sm={{ span: "12", order: "0" }}
            md={{ span: "4", order: "0" }}
            className="textLeft"
          >
            <a
              href="/#"
              className="noPadding"
              onClick={() => {
                openInNewTab(
                  "https://drive.google.com/drive/folders/16XXdoKT7Z2gAv7G6tUEVnCzEF84DVngz"
                );
              }}
            >
              Press Material
            </a>

            <p>
              Contacts:
              <br></br>
              <span className="smallText">
                creators@upfoxlabs.com
                <br></br>
                press@upfoxlabs.com
              </span>
            </p>
          </Col>
          <Col sm={{ span: "12", order: "2" }} md={{ span: "4", order: "1" }}>
            <p className="smallText">
              &copy; 2023 Upfox Labs. All Rights Reserved.
            </p>
          </Col>
          <Col sm={{ span: "12", order: "1" }} md={{ span: "4", order: "2" }}>
            <a
              className="socialIconFooter"
              href="https://store.steampowered.com/app/2452320/Folly_Of_The_Wizards/"
              rel="noopener noreferrer"
              target="_blank"
            >
              <FaSteam></FaSteam>
            </a>
            <a
              className="socialIconFooter"
              href="https://twitter.com/FollyOTWizards"
              rel="noopener noreferrer"
              target="_blank"
            >
              <FaTwitter></FaTwitter>
            </a>
            {/* <a className='socialIconFooter' href="/#" rel="noopener noreferrer" target="_blank"  ><FaTiktok></FaTiktok></a> */}
            <a
              className="socialIconFooter"
              href="https://www.youtube.com/@FollyOfTheWizards"
              rel="noopener noreferrer"
              target="_blank"
            >
              <FaYoutube></FaYoutube>
            </a>
            <a
              className="socialIconFooter"
              href="https://instagram.com/FollyOfTheWizards"
              rel="noopener noreferrer"
              target="_blank"
            >
              <FaInstagram></FaInstagram>
            </a>
          </Col>
        </Row>
      </Container>
      <div className="lastDiv showMobile"></div>
      <Modal open={openModal} onClose={() => setOpenModal(false)} />
    </Container>
  );
};

export default Home;
